export default function loopArrayIndex(dir, array, index) {
  const length = array.length;
  let nextIndex;
  if (dir) {
    nextIndex = (index + 1) % length;
  } else {
    nextIndex = (index - 1 + length) % length;
  }
  return nextIndex;
}